import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";
import { UnitType } from "../../generated";

const DropdownList = Dropdown<UnitType>();
interface Props {
    value: UnitType,
    onChange: (type: UnitType) => void
    error?: string;
    label?: string;
}

export function GetUnitDescription(type: UnitType) {
    switch (type) {
        case UnitType.Pieces:
            return "pz";
        case UnitType.Hours:
            return "ore"
        case UnitType.Days:
            return "giorni"
        case UnitType.Months:
            return "mesi"
        case UnitType.Km:
            return "km"
        case UnitType.Liters:
            return "litri"
        case UnitType.Kg:
            return "kg"
    }
}
class __InterventoRowTypeSelector extends React.PureComponent<Props>{
    render() {
        const { onChange, value, error, label } = this.props;
        const data = [UnitType.Pieces, UnitType.Hours, UnitType.Days, UnitType.Km, UnitType.Kg, UnitType.Months, UnitType.Liters]
        return <DropdownList
            label={label}
            data={data}
            textField={x => GetUnitDescription(x)}
            onSelect={onChange}
            value={value}
            error={error}
        />;
    }
}
export const InterventoRowTypeSelector = formGroup(__InterventoRowTypeSelector);
